export enum FriendStatus {
    Friends = 'Friends',
    NotFriends = 'NotFriends',
    Invited = 'Invited'
}
